import type { OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Feature, FeatureFlagsService } from '@freelancer/feature-flags';
import { map, type Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-navigation-secondary-finances',
  template: `
    @if (showSecondaryNav$ | flAsync) {
      <app-bar flTrackingSection="SubnavFinances">
        <app-bar-item
          link="/users/financial-dash"
          i18n="Secondary navigation finances bar item"
          flTrackingLabel="Finances"
          [exactLink]="true"
        >
          Finances
        </app-bar-item>
        <app-bar-item
          link="/payments/transactions.php"
          i18n="Secondary navigation finances bar item"
          flTrackingLabel="TransactionHistory"
          [exactLink]="true"
        >
          Transaction History
        </app-bar-item>
        <app-bar-item
          [link]="'/verify'"
          [queryParams]="{ w: 't' }"
          i18n="Secondary navigation finances bar item"
          flTrackingLabel="VerifyPaymentMethod"
          [exactLink]="true"
        >
          Verify Payment Method
        </app-bar-item>
        <app-bar-item
          link="/deposit"
          i18n="Secondary navigation finances bar item"
          flTrackingLabel="DepositFunds"
          [exactLink]="true"
        >
          Add Funds
        </app-bar-item>
        <app-bar-item
          [link]="
            (useExpressWithdrawalOnly$ | flAsync)
              ? '/payments/withdraw/withdraw.php'
              : '/payments/withdraw.php'
          "
          [queryParams]="
            (useExpressWithdrawalOnly$ | flAsync)
              ? { method: 'withdraw.express' }
              : {}
          "
          i18n="Secondary navigation finances bar item"
          flTrackingLabel="WithdrawMoney"
          [exactLink]="true"
        >
          Withdraw Money
        </app-bar-item>
        <app-bar-item
          link="/tax"
          i18n="Secondary navigation tax statements bar item"
          flTrackingLabel="TaxStatements"
          [exactLink]="true"
        >
          Tax Statements
        </app-bar-item>
      </app-bar>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationSecondaryFinancesComponent implements OnInit {
  showSecondaryNav$: Observable<boolean>;
  useExpressWithdrawalOnly$: Observable<boolean>;

  constructor(private featureFlag: FeatureFlagsService) {}

  ngOnInit(): void {
    this.useExpressWithdrawalOnly$ = this.featureFlag.getFlag(
      Feature.USE_EXPRESS_WITHDRAWAL_ONLY,
    );

    this.showSecondaryNav$ = this.featureFlag
      .getFlag(Feature.MOVE_SECONDARY_NAV_LINKS)
      .pipe(map(isEnabled => !isEnabled));
  }
}
